import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormArray, NgForm, ReactiveFormsModule } from '@angular/forms';
import { FormBuilder, Validators } from '@angular/forms';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { APIHeaderService } from '../../_services/header/API-header';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { APIEntityService } from '../../_services/entity/API-entity';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Router, ActivatedRoute } from '@angular/router';
import { BadWordsApiService } from 'src/app/_root/Trai_module/_services/bad-words/bad-words-api.service';
import { APILoginService } from '../../_services/login/API-login';
import { ModalPromptComponent } from '../../../../_helpers/Modals/prompt/modal.prompt';
import { Constants } from '../../../../_utils/Constants';
import { formatDate } from '@angular/common';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-extension-conversion-headers',
  templateUrl: './extension-conversion-headers.component.html',
  styleUrls: ['./extension-conversion-headers.component.css']
})
export class ExtensionConversionHeadersComponent implements OnInit {
  extconvForm: FormGroup;
  HeaderDetails: any;
  displayExtension = "start";
  submitted = false;
  cli: any;
  validity: any;
  disableAction = false;
  headerID: any;
  modalRef: any;
  peid: any;
  returnedValue: any;
  hid: string;



  constructor(private fb: FormBuilder,
    private ls: APILoginService,
    private es: APIEntityService,
    private hs: APIHeaderService,
    private $modal: $ModalManagerService,
    private db: $DBManagerService,
    private modalService: BsModalService,
    private _route: ActivatedRoute,
    private bw: BadWordsApiService,
    private router: Router) {

  }
  get f() { return this.extconvForm.controls; }

  public hdervalidity = [
    { value: "15", viewValue: "15" },
    { value: "30", viewValue: "30" },
    { value: "45", viewValue: "45" },
    { value: "60", viewValue: "60" },

  ]

  ngOnInit() {
    this.extconvForm = this.fb.group({
      cli: [''],
      validityTill: [''],
      status: [''],
      action: ['', [Validators.required]],
      renewalcount: [''],
      hclass: [''],
      extension: [''],
      conversion: [''],
      validity: ['',],
      // newvaliditytill: ['']

    })
    this._route.params.subscribe((params) => {
      this.headerID = params['urn'];

      console.log("The Hid is", this.headerID)

    })
    this.getHeaderDetails();
  }

  onChangeAction(event) {
    console.log("----------event-------------", event, event.value)
    if (event.value == "Extension") {

      this.displayExtension = 'true'
      this.extconvForm.controls['conversion'].reset();
      this.extconvForm.controls['conversion'].disable();
      this.extconvForm.controls['extension'].enable();
      this.extconvForm.controls['validity'].setValidators([Validators.required])
      this.extconvForm.controls['validity'].updateValueAndValidity();



    }
    else {
      this.displayExtension = 'false'
      this.extconvForm.controls['extension'].reset();
      this.extconvForm.controls['extension'].disable();
      this.extconvForm.controls['conversion'].enable();

    }

  }

  onselectValidity(event) {
    let newdt;

    console.log("------------New Performing date operarion-----------", event.value)
    const date = new Date();


    // switch (event.value) {
    //   case "15":
    //     var valitytill = new Date().setDate(date.getDate() + 15);
    //     newdt = formatDate(valitytill, 'yyyy-MM-dd', 'en-US', '+0530');
    //     this.extconvForm.controls['newvaliditytill'].setValue(newdt);
    //     break;
    //   case "30":
    //     var valitytill = new Date().setDate(date.getDate() + 30);
    //     newdt = formatDate(valitytill, 'yyyy-MM-dd', 'en-US', '+0530');
    //     this.extconvForm.controls['newvaliditytill'].setValue(newdt);
    //     break;
    //   case "45":
    //     var valitytill = new Date().setDate(date.getDate() + 45);
    //     newdt = formatDate(valitytill, 'yyyy-MM-dd', 'en-US', '+0530');
    //     this.extconvForm.controls['newvaliditytill'].setValue(newdt)
    //     break;
    //   case "60":
    //     var valitytill = new Date().setDate(date.getDate() + 60);
    //     newdt = formatDate(valitytill, 'yyyy-MM-dd', 'en-US', '+0530');
    //     this.extconvForm.controls['newvaliditytill'].setValue(newdt)
    //     break;

    // }


  }

  onSubmit() {
    // if (this.extconvForm.invalid) {
    //   alert("Please provide values in mandatory fields")
    // }
    // else {
    this.peid = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
    if (this.displayExtension == 'true') {
      if (this.extconvForm.invalid) {
        alert("Please provide values in mandatory fields")
      }
      else {
        let data = {
          cli: this.cli,
          validity: this.validity,
          entityID: this.peid,
          hclass: "Temporary",
          orgname: this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_NAME),    
          Email: this.db.get(Constants.SESSSION_STORAGE, Constants.Entity_EmailID)
        }
        this.modalRef = this.modalService.show(ModalPromptComponent);
        this.modalRef.content.modalDataObj = {
          title: "Extension Conversion Headers",
          msg: "Are You Sure Extend the Header. Do you want to continue?",

        }
        this.modalRef.content.onClose.subscribe(result => {
          this.returnedValue = result
          console.log("results", result)
          if (this.returnedValue === true) {
            this.hs.temporaryHeaderExtension(data)
              .subscribe(r => {
                console.log("response -- ", r);
                console.log("status ", r.status);
                if (r.status == "success") {
                  //this.displayExtension='true'  

                  this.disableAction = true
                  this.$modal.successModal({
                    title: 'Extension Conversion Headers',
                    msg: 'Header Validity Extended Succesfully and New Validity is ' + r.Message
                  });
                  this.submitted = true;
                  this.router.navigateByUrl('/headers-by-pe');
                }
                else if (r.status == "Failed") {
                  this.$modal.errorModal({
                    title: 'Extension Conversion Headers',
                    msg: r.Message
                  });
                }
                else {
                  this.$modal.errorModal({
                    title: 'Extension Conversion Headers',
                    msg: 'Some Error Ocurred'
                  });
                }


              })

          }
        })
      }
    }
    else if (this.displayExtension == 'false') {
      let data = {
        cli: this.cli,
        // validity: this.validity,
        entityID: this.peid,
        urn :this.headerID,
        orgname: this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_NAME),    
        Email: this.db.get(Constants.SESSSION_STORAGE, Constants.Entity_EmailID), 
        hid: this.hid
      }
      this.modalRef = this.modalService.show(ModalPromptComponent);
      this.modalRef.content.modalDataObj = {
        title: "Extension Conversion Headers",
        msg: "Are you sure to Convert the Temporary header to Permanent header. Do you want to continue?",
      }
      this.modalRef.content.onClose.subscribe(result => {
        this.returnedValue = result
        console.log("results", result)
        if (this.returnedValue == true) {
          this.hs.temporaryHeaderConversion(data)
            .subscribe(r => {
              console.log("response -- ", r);
              console.log("status ", r.status);
              if (r.status == "success") {
                this.disableAction = true
                this.$modal.successModal({
                  title: 'Extension Conversion Headers',
                  msg: 'Temporary Header has been Succesfully converted to Permanent.'
                });
                this.submitted = true;
                this.router.navigateByUrl('/headers-by-pe');
              }
              else if (r.status == "Failed") {
                this.$modal.errorModal({
                  title: 'Extension Conversion Headers',
                  msg: r.Message
                });
              }
              else {
                this.$modal.errorModal({
                  title: 'Extension Conversion Headers',
                  msg: 'Some Error Ocurred'
                });
              }

            })

        }
      })
    }

    //  }

  }

  getHeaderDetails() {
    var data = {
      urn: this.headerID,
    }
    this.hs.getOneHeaderFromMongo(data)
      .subscribe(r => {

        if (r.validHeader == true) {
          this.HeaderDetails = r;

          this.extconvForm.controls['cli'].setValue(r.cli);
          this.cli = r.cli
          console.log("-----this.cli-----", this.cli)
          this.extconvForm.controls['validityTill'].setValue(r.hdrValidityTill);
          //this.extconvForm.controls['validityTill'].setValue(moment(r.hdrValidityTill).tz('Asia/Kolkata').format('LLL')); // DD-MM-YYYY HH:mm
          this.hid = r.hid

          if (r.sts == "A")
            this.extconvForm.controls['status'].setValue("Active");  
          else if (r.sts == "SC")
            this.extconvForm.controls['status'].setValue("Suspended By customer");
          else if (r.sts == "SU")
            this.extconvForm.controls['status'].setValue("Suspended as Unused");
          else if (r.sts == "SV" && r.hclass == "Permanent")
            this.extconvForm.controls['status'].setValue("Suspended due to Verification");
          else if (r.sts == "SV" && r.hclass == "Temporary")
            this.extconvForm.controls['status'].setValue("Suspended as Validity expired");
          else
            this.extconvForm.controls['status'].setValue(r.sts);
          
          this.extconvForm.controls['renewalcount'].setValue(r.renewalCnt);
          this.extconvForm.controls['hclass'].setValue(r.hclass);
        }

        else {
          this.$modal.errorModal({
            title: 'Extension Conversion Headers',
            msg: "Error Occured while retrieving Header Details"
          });

        }

      })

  }

}
